import React from 'react';

enum ENotificationType {
  /**
   * @deprecated Use SUCCESS instead
   */
  success = 'success',
  /**
   * @deprecated Use INFO instead
   */
  info = 'info',
  /**
   * @deprecated Use WARNING instead
   */
  warning = 'warning',
  /**
   * @deprecated Use ERROR instead
   */
  error = 'error',

  SUCCESS = 'SUCCESS',
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

type TNotificationType = keyof typeof ENotificationType;

type TLifeDuration = number | 'infinity';

type TNewNotification = {
  id?: number | string;
  createdAt: number;
  title?: string;
  message?: React.ReactNode;
  messageKey?: string;
  messageArgs?: Record<string, string | number>;
  lifeDuration?: TLifeDuration;
  type?: TNotificationType;
  onClick?: () => void;
  onClose?: () => void;
  onCloseButtonClick?: () => void;
  closeButtonText?: string;
  isPermanent?: boolean;
};

type TNewNotificationOptions = Omit<TNewNotification, 'createdAt'>;

const DEFAULT_DURATION = 5_000;
const DUPLICATE_IGNORE_DURATION = 1_000;
const DEFAULT_VISIBLE_COUNT = 2;
const DEFAULT_NOTIFICATION_OFFSET = 16;
const DEFAULT_TYPE = ENotificationType.INFO;

export type {TNotificationType, TNewNotification, TLifeDuration, TNewNotificationOptions};
export {
  DEFAULT_TYPE,
  DEFAULT_DURATION,
  DEFAULT_VISIBLE_COUNT,
  DUPLICATE_IGNORE_DURATION,
  DEFAULT_NOTIFICATION_OFFSET,
  ENotificationType,
};
